import * as QueryString from "query-string";
import { analyticsCopilotWidgetsSectionId } from "./constants";
export const shouldAddPdfExport = (componentName, widgetWithoutData, sectionId, mode, disablePdfExport) => componentName !== undefined &&
    componentName &&
    !widgetWithoutData &&
    componentName !== "InsDatapointGridWidget" &&
    sectionId !== analyticsCopilotWidgetsSectionId &&
    mode !== "comparison" &&
    !disablePdfExport;
export const getCommentsPayload = (request) => {
    const queryParameters = {};
    if (request.referenceDate) {
        queryParameters["referenceDate.year"] = request.referenceDate.getFullYear();
        queryParameters["referenceDate.day"] = request.referenceDate.getDate();
        queryParameters["referenceDate.month"] = request.referenceDate.getMonth() + 1;
    }
    const optionalFields = ["entityId", "entityType", "widgetId", "relationId"];
    optionalFields.forEach((field) => {
        if (request[field] !== undefined) {
            queryParameters[field] = request[field];
        }
    });
    return QueryString.stringify(queryParameters) ? `?${QueryString.stringify(queryParameters)}` : "";
};
